'use es6';

export const OPTIN_VIEW_CURRENT = 'CURRENT';
export const OPTIN_VIEW_NEW = 'NEW';
export const AUTO_MINIMIZE_TIMEOUT = 10000;